/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { TCaseModuleModalRootTypes, useCaseModuleModalRootStore } from './case-modal-root.store';
import CreateLabelAutoModal from '../../../label-auto/components/modals/create-label-auto-modal';
import UpdateLabelAutoModal from '../../../label-auto/components/modals/update-label-auto-modal';
import DeleteLabelAutoModal from '../../../label-auto/components/modals/delete-label-auto-modal';
import CreateLabelCaseModal from '../../../label-case/components/modals/create-label-case-modal';
import UpdateLabelCaseModal from '../../../label-case/components/modals/update-label-case-modal';
import DeleteLabelCaseModal from '../../../label-case/components/modals/delete-label-case-modal';
import CreateLabelChatModal from '../../../label-chat/components/modals/create-label-chat-modal';
import UpdateLabelChatModal from '../../../label-chat/components/modals/update-label-chat-modal';
import DeleteLabelChatModal from '../../../label-chat/components/modals/delete-label-chat-modal';
import FilterCaseModal from '../../../case/components/modals/filter-case-modal';
import AssignCaseToMeModal from '../../../case/components/modals/assign-case-to-me-modal';
import AssignCaseToOtherModal from '../../../case/components/modals/assign-case-to-other-modal';
import CloseCaseModal from '../../../case/components/modals/close-case-modal';
import ResolveCaseModal from '../../../case/components/modals/resolve-case-modal';
import AssignLabelCaseModal from '../../../label-case/components/modals/assign-label-case-modal/assign-label-case-modal';
import BulkAssignLabelCaseModal from '../../../label-case/components/modals/bulk-assign-label-case-modal';
import AssignLabelChatModal from '../../../label-chat/components/modals/assign-label-chat-modal';
import DeleteReplyTemplateModal from '../../../case/components/modals/delete-reply-template-modal/delete-reply-template-modal';
import UpdateReplyTemplateModal from '../../../case/components/modals/update-reply-template-modal/update-reply-template-modal';
import CreateReplyTemplateModal from '../../../case/components/modals/create-reply-template-modal/create-reply-template-modal';
import SelectReplyTemplateModal from '../../../case/components/modals/select-reply-template-modal/select-reply-template-modal';

const modalMap: Partial<Record<TCaseModuleModalRootTypes, React.ComponentType<any>>> = {
  // Label Auto Modal
  CreateLabelAutoModal,
  UpdateLabelAutoModal,
  DeleteLabelAutoModal,
  // Label Case Modal
  CreateLabelCaseModal,
  UpdateLabelCaseModal,
  DeleteLabelCaseModal,
  // Label Chat Modal
  CreateLabelChatModal,
  UpdateLabelChatModal,
  DeleteLabelChatModal,
  // Case Modal
  FilterCaseModal,
  AssignCaseToMeModal,
  AssignCaseToOtherModal,
  CloseCaseModal,
  ResolveCaseModal,
  AssignLabelCaseModal,
  BulkAssignLabelCaseModal,
  AssignLabelChatModal,
  DeleteReplyTemplateModal,
  UpdateReplyTemplateModal,
  CreateReplyTemplateModal,
  SelectReplyTemplateModal,
};

// Memoize valid types to avoid recreating on every render
const validCaseModalTypes = Object.keys(modalMap) as TCaseModuleModalRootTypes[];

const CaseModuleModalRoot = memo(() => {
  // Optimized: Only subscribe to modals that belong to this root
  // This prevents re-renders when other modal roots change
  const modals = useCaseModuleModalRootStore(
    useShallow((state) => state.modals.filter((modal) => validCaseModalTypes.includes(modal.type)))
  );

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];
        const key = `${type}-${idx + 1}`;

        if (!ModalComponent) return null;

        return <ModalComponent key={key} {...props} />;
      })}
    </>
  );
});
CaseModuleModalRoot.displayName = 'CaseModuleModalRoot';
export default CaseModuleModalRoot;
